import { showErrorToast } from 'src/app/demo/utilities/toast-utils';
import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { FileUploadHandlerEvent, FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { InsuranceProvidersService } from 'src/app/demo/service/insurance-providers.service';
import { TranslateService } from '@ngx-translate/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-provider-detail',
    standalone: true,
    imports: [
        CommonModule,
        FileUploadModule,
        ButtonModule,
        FormsModule,
        ReactiveFormsModule,
        ToastModule,
    ],
    templateUrl: './provider-detail.component.html',
    styleUrl: './provider-detail.component.scss',
    providers: [MessageService],
})
export class ProviderDetailComponent {
    router = inject(Router);
    route = inject(ActivatedRoute);
    insuranceProviderService = inject(InsuranceProvidersService);
    messageService = inject(MessageService);
    translate = inject(TranslateService);
    fb = inject(FormBuilder);
    providerService = inject(InsuranceProvidersService);
    sanitizer = inject(DomSanitizer);

    documentForm!: FormGroup;

    providerId = signal<string>('');
    uploading = signal<boolean>(false);
    selectedFile = signal<File | null>(null);
    providerDetail = signal<any>(null);
    blobUrl = signal<string>('');

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.providerId.set(params['id']);
            this.fetchProviderInfo();
        });
        this.initializeForm();
    }

    initializeForm() {
        this.documentForm = this.fb.group({
            file: [],
        });
    }

    fetchProviderInfo() {
        this.insuranceProviderService
            .fetchProvider(this.providerId())
            .subscribe({
                next: (res: any) => {
                    this.providerDetail.set(res);
                },
                error: (error: any) => {
                    showErrorToast(
                        error.error.message,
                        this.messageService,
                        this.translate
                    );
                },
            });
    }

    uploadForm = this.fb.group({
        contents: ['', Validators.required],
    });

    onFileSelect(event: any) {
        this.selectedFile = event.files[0];
        this.documentForm.get('file')?.setValue(this.selectedFile);
    }

    onUploadClicked(event: FileUploadHandlerEvent) {
        this.validateDataAndEmit(event);
    }

    validateDataAndEmit(event: FileUploadHandlerEvent) {
        const file = event.files[0];
        console.log(file);
        const formData = new FormData();
        formData.append('contents', file, file.name);
        console.log(formData);
        this.uploadCompanyLogo(formData);
    }

    uploadCompanyLogo(formData: any) {
        this.insuranceProviderService
            .uploadLogo(this.providerId(), formData)
            .subscribe({
                next: (value) => {
                    if (value['mimeType'] === 'image/png' || value['mimeType'] === 'image/jpeg' || value['mimeType'] === 'image/svg') {
                        const byteCharacters = atob(value['content']);
                        const byteNumbers = new Uint8Array(
                            byteCharacters.length
                        );
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const blobItem = new Blob([byteNumbers], {
                            type: value['mimeType'],
                        });
                        this.blobUrl.set(URL.createObjectURL(blobItem));
                    } else {
                      console.log("Invalid mime-type")
                    }
                    
                },
                error: (err) => {
                    console.log(err);
                },
            });
    }

    backClicked() {
        this.router.navigate(['/home/insurance-providers']);
    }

    onFileClear() {
        this.documentForm.get('file')?.setValue(null);
    }
}
